module.exports = __webpack_public_path__ + "img/popup_bg_play.8ce5d976.png";